export const classes = {
  base: 'flex min-h-0 flex-col',
  left: 'border-r border-white/70 bg-[linear-gradient(160deg,rgba(255,238,230,0.72),rgba(255,255,255,0.22))] px-[44px] pb-[34px] pt-[44px] dark:border-white/10 dark:bg-[linear-gradient(160deg,rgba(255,150,95,0.14),rgba(255,255,255,0.02))]',
  right:
    'bg-[linear-gradient(180deg,rgba(241,90,43,0.05),transparent_46%)] dark:bg-[linear-gradient(180deg,rgba(255,122,77,0.06),transparent_46%)]',
};
